<template>
  <div class="purchased-page">
    <!-- Header -->
    <div class="page-header">
       <span class="header-icon"><van-icon name="wap-nav" /></span>
       <span class="header-title">已购买影片</span>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="loading-state">
       <van-loading size="24px" color="#ffaa00">加载中...</van-loading>
    </div>

    <!-- Empty State -->
    <div v-else-if="purchasedVideos.length === 0" class="empty-state">
       暂无已购买的影片
    </div>

    <!-- Video List -->
    <div v-else class="video-list">
       <div 
         class="video-item" 
         v-for="video in purchasedVideos" 
         :key="video.id"
         @click="goToPlayer(video)"
       >
         <div class="video-cover">
            <van-image :src="video.coverUrl" fit="cover" class="cover-img" />
            <div class="video-duration">{{ video.duration || '00:00' }}</div>
         </div>
         <div class="video-info">
            <div class="video-title clamp-2">{{ video.title }}</div>
            <div class="video-meta">
              <span class="purchase-date">购买于 {{ formatDate(video.purchasedAt) }}</span>
            </div>
         </div>
       </div>
    </div>

    <!-- Bottom Nav -->
    <div class="bottom-nav">
      <div class="nav-item" @click="$router.push('/home').catch(()=>{})">
        <div class="nav-btn btn-dark">首页</div>
      </div>
      <div class="nav-item">
        <div class="nav-btn btn-yellow">已购买</div>
      </div>
      <div class="nav-item" @click="$router.push('/user')">
        <div class="nav-btn btn-yellow">账号</div>
      </div>
      <div class="nav-item" @click="showBookmarkModal = true">
        <div class="nav-btn btn-dark">收藏本站</div>
      </div>
    </div>

    <!-- Bookmark Modal -->
    <div class="modal-mask" v-if="showBookmarkModal">
       <div class="modal-box">
          <div class="modal-header">
             <span>收藏本站 永不迷路</span>
             <div class="close-btn" @click="showBookmarkModal = false">
               <van-icon name="cross" size="20" color="#fff" />
             </div>
          </div>
          <div class="modal-body">
             <div class="green-text">
                重要提示!!!请截图保存本站最新网址! ! ! 已付款的请在已购处播放!
             </div>
             <div class="orange-label">永久网址:</div>
             <div class="url-row">
                <span class="url-text">http://36x3.vip</span>
                <button class="copy-btn" @click="copyUrl">复制</button>
             </div>
             <div class="qr-label">截图保存本站二维码:</div>
             <div class="qr-box">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=http://36x3.vip" alt="QR" />
             </div>
          </div>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Purchased',
  data() {
    return {
      purchasedVideos: [],
      loading: true,
      showBookmarkModal: false
    }
  },
  mounted() {
    this.fetchPurchasedVideos();
  },
  methods: {
    async fetchPurchasedVideos() {
      try {
        this.loading = true;
        
        // Get user info
        const userStr = localStorage.getItem('user');
        const deviceId = localStorage.getItem('deviceId');
        
        let params = {};
        if (userStr) {
          const user = JSON.parse(userStr);
          params.username = user.username;
        } else if (deviceId) {
          params.deviceId = deviceId;
        } else {
          this.loading = false;
          return;
        }
        
        const { data } = await this.$http.get('/user/purchased', { params });
        this.purchasedVideos = data.purchases || [];
      } catch (e) {
        console.error('Failed to fetch purchased videos:', e);
      } finally {
        this.loading = false;
      }
    },
    goToPlayer(video) {
      // 直接跳转到播放页面，让 Player.vue 处理权限检查
      this.$router.push({
        path: '/player',
        query: {
          id: video.id,
          url: video.videoUrl,
          title: video.title
        }
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2,'0')}-${date.getDate().toString().padStart(2,'0')}`;
    },
    toggleBookmark() {
      this.showBookmarkModal = true;
    },
    copyUrl() {
      const input = document.createElement('input');
      input.setAttribute('value', 'http://36x3.vip');
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast.success('复制成功');
    }
  }
}
</script>

<style scoped>
.purchased-page {
    background-color: #111;
    min-height: 100vh;
    color: #fff;
    font-family: sans-serif;
    padding-bottom: 70px;
}
.page-header {
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #fff;
    background: #1a1a1a;
}
.header-icon { 
    margin-right: 10px; 
    color: #ffaa00; 
    font-size: 20px;
}

.loading-state {
    display: flex;
    justify-content: center;
    padding: 40px;
}

.empty-state {
    padding: 40px 15px;
    font-size: 16px;
    color: #888;
    text-align: center;
}

/* Video List */
.video-list {
    padding: 10px;
}

.video-item {
    display: flex;
    background: #1a1a1a;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    cursor: pointer;
}

.video-item:active {
    opacity: 0.8;
}

.video-cover {
    width: 120px;
    height: 80px;
    flex-shrink: 0;
    position: relative;
}

.cover-img {
    width: 100%;
    height: 100%;
}

.video-duration {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background: rgba(0,0,0,0.7);
    color: #fff;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 2px;
}

.video-info {
    flex: 1;
    padding: 8px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.video-title {
    font-size: 14px;
    line-height: 1.3;
    color: #fff;
}

.clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.video-meta {
    font-size: 12px;
    color: #888;
}

.purchase-date {
    color: #ffaa00;
}

/* Bottom Nav */
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #111;
    display: flex;
    padding: 5px 0;
    border-top: 1px solid #333;
    z-index: 100;
}
.nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nav-btn {
    width: 80%;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    border-radius: 4px;
    font-weight: bold;
}
.btn-dark {
    background-color: #222;
    color: white;
    border: 1px solid #444;
}
.btn-yellow {
    background-color: #ffaa00;
    color: black;
}

/* Bookmark Modal Styles */
.modal-mask {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-box {
    background: #1a1a2e;
    border-radius: 8px;
    width: 90%;
    max-width: 400px;
    overflow: hidden;
}
.modal-header {
    background: #222;
    color: #ffa500;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}
.close-btn { cursor: pointer; }
.modal-body {
    padding: 15px;
    text-align: center;
}
.green-text {
    color: #00ff00;
    font-size: 14px;
    margin-bottom: 10px;
}
.orange-label {
    color: #ffa500;
    margin: 10px 0 5px;
}
.url-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}
.url-text {
    color: #4fc3f7;
    font-size: 20px;
    font-weight: bold;
}
.copy-btn {
    background: #ffa500;
    color: #000;
    border: none;
    padding: 5px 15px;
    border-radius: 15px;
    cursor: pointer;
}
.qr-label {
    color: #ffa500;
    margin: 10px 0;
}
.qr-box img {
    background: white;
    padding: 10px;
    border-radius: 5px;
}
</style>
